import { Footer } from '@/app/components/Footer'
import { ISubcategoryPageHit } from '@/types/search'
import { InitialResults } from 'instantsearch.js'
import Head from 'next/head'
import { useMemo } from 'react'
import { InstantSearch, InstantSearchSSRProvider } from 'react-instantsearch'
import { CollectionSearchParameters } from 'typesense-instantsearch-adapter'
import { SearchInputProvider } from '../../course/contexts/InputSearchContext'
import { Header } from '../../shared/components/Header'
import { Newsletter } from '../../shared/components/Newsletter'
import { AvailableLanguages } from '../../shared/providers/LanguageSelectionProvider'
import { SubCategoryPageCSRResults } from '../components/SubCategoryPageCSRResults'
import { TaxonomyPageHeader } from '../components/TaxonomyPageHeader'
import { getSearchClient } from '../lib/search-client'

type SubCategoryPageProps = {
  subCategory: ISubcategoryPageHit
  csrSearchConfig: CollectionSearchParameters
  initialResults?: InitialResults
  locale: AvailableLanguages
}

export function SubCategoryPage({
  subCategory,
  csrSearchConfig,
  initialResults,
  locale,
  ...props
}: SubCategoryPageProps) {
  const client = useMemo(
    () =>
      getSearchClient('', {
        collectionSpecificSearchParameters: {
          courses: {
            ...csrSearchConfig.courses,
          },
        },
      }),
    [csrSearchConfig]
  )

  return (
    <>
      <Head>
        <title>{`${subCategory.name} | Mydra`}</title>
      </Head>
      <SearchInputProvider>
        <Header className="z-40" />
        <TaxonomyPageHeader taxonomy={subCategory} locale={locale} />
        <main {...props} className="container mb-16 mt-12">
          <InstantSearchSSRProvider initialResults={initialResults}>
            <InstantSearch
              indexName="courses"
              searchClient={client}
              stalledSearchDelay={500}
              routing={false}
              future={{
                preserveSharedStateOnUnmount: true,
              }}
            >
              <SubCategoryPageCSRResults locale={locale} />
            </InstantSearch>
          </InstantSearchSSRProvider>
        </main>
        <div className="bg-mydra-black pt-9">
          <Newsletter />
        </div>
        <Footer />
      </SearchInputProvider>
    </>
  )
}
